// extracted by mini-css-extract-plugin
module.exports = {"stretch-column":"components-FullHeightColumn-FullHeightColumn__stretch-column--3jKIT","stretch-row":"components-FullHeightColumn-FullHeightColumn__stretch-row--1GpNn"};